import { useState, useEffect } from "react"
import {
  getLocalizedPath,
  getPathLanguage,
  normalizeRoutePath,
} from "../utils/authLanguageRoutes"

const useLanguage = () => {
  const getResolvedLanguage = () =>
    getPathLanguage(window.location.pathname) ||
    localStorage.getItem("language") ||
    "ar"

  const [language, setLanguage] = useState(getResolvedLanguage)

  // Set the document direction based on language
  useEffect(() => {
    const savedLang = getResolvedLanguage()
    localStorage.setItem("language", savedLang)
    setLanguage(savedLang)
    document.documentElement.setAttribute(
      "dir",
      savedLang === "ar" ? "rtl" : "ltr"
    )
  }, [])

  // Handle language change
  const handleLanguageChange = (lang) => {
    localStorage.setItem("language", lang)
    setLanguage(lang)

    const localizedPath = getLocalizedPath(window.location.pathname, lang)
    const currentPath = normalizeRoutePath(window.location.pathname)

    if (localizedPath !== currentPath) {
      window.location.assign(
        `${localizedPath}${window.location.search}${window.location.hash}`
      )
      return
    }

    window.location.reload()
  }

  return {
    language,
    handleLanguageChange,
  }
}

export default useLanguage
